import { render, staticRenderFns } from "./PatientCosts.vue?vue&type=template&id=97a2c11c&scoped=true&"
import script from "./PatientCosts.vue?vue&type=script&lang=js&"
export * from "./PatientCosts.vue?vue&type=script&lang=js&"
import style0 from "./PatientCosts.vue?vue&type=style&index=0&id=97a2c11c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97a2c11c",
  null
  
)

export default component.exports